import { Edit, Save, Close } from '@mui/icons-material';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  SxProps,
} from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { GENERAL_FONT } from '../../constants/theme';

export interface TextFieldWithButtonProps {
  onSave: (data: string) => void;
  label: string;
  data: string;
  noEdit?: boolean;
  currentlyEdited?: boolean;
  onEditStart?: (data: string) => void;
}

const disabledFieldColorSx: SxProps = {
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'black !important',
    fontFamily: GENERAL_FONT,
  },
  '& .MuiOutlinedInput-input': {
    WebkitTextFillColor: 'black !important',
    fontFamily: GENERAL_FONT,
  },
  '& .Mui-disabled': {
    WebkitTextFillColor: 'black !important',
    fontFamily: GENERAL_FONT,
  },
};

const TextFieldWithButton = (props: TextFieldWithButtonProps) => {
  const {
    label,
    data,
    onSave: onEdit,
    noEdit,
    onEditStart,
    currentlyEdited,
  } = props;

  const [disabledEditing, setDisabledEdit] = React.useState(true);
  const [newValue, setNewValue] = React.useState(data);

  useEffect(() => {
    if (!currentlyEdited) {
      setDisabledEdit(true);
      setNewValue(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- resets only when editing ends, so a data change outside editing shows after the next edit
  }, [currentlyEdited]);

  const onEditClick = () => {
    setDisabledEdit(false);
    onEditStart?.(label);
  };
  const onCloseClick = () => {
    setNewValue(data);
    setDisabledEdit(true);
    onEditStart?.('');
  };
  const onSaveClick = () => {
    onEdit(newValue);
    setDisabledEdit(true);
  };
  const renderEndAdornment = () => {
    if (noEdit) {
      return null;
    }
    if (disabledEditing) {
      return (
        <InputAdornment position="end">
          <IconButton aria-label="Edit" edge="end" onClick={onEditClick}>
            <Edit />
          </IconButton>
        </InputAdornment>
      );
    }
    return (
      <InputAdornment position="end">
        <IconButton aria-label="Close" edge="end" onClick={onCloseClick}>
          <Close />
        </IconButton>
        <IconButton aria-label="Save" edge="end" onClick={onSaveClick}>
          <Save />
        </IconButton>
      </InputAdornment>
    );
  };
  return (
    <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        disabled={disabledEditing}
        sx={disabledFieldColorSx}
        value={newValue}
        id={`${label}TextField`}
        type="text"
        onChange={(event) => setNewValue(event.target.value)}
        endAdornment={renderEndAdornment()}
        label={label}
      />
    </FormControl>
  );
};

export default TextFieldWithButton;
